import { render, staticRenderFns } from "./ArchiveMatch.vue?vue&type=template&id=3572c412&scoped=true&"
import script from "./ArchiveMatch.vue?vue&type=script&lang=js&"
export * from "./ArchiveMatch.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveMatch.vue?vue&type=style&index=0&id=3572c412&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3572c412",
  null
  
)

export default component.exports